"use client";

import { BagTotals, formatUsd } from "@/lib/comix/bagConfig";
import PrimaryButton from "@/components/shared/PrimaryButton";
import SecondaryButton from "@/components/shared/SecondaryButton";
import { trackEvent } from "@/lib/amplitude";

export default function BagSummary({
  totals,
  checkoutUrl,
  onCheckout,
  onCreateAnother,
  isSyncing,
}: {
  totals: BagTotals;
  checkoutUrl: string;
  onCheckout: () => void;
  onCreateAnother: () => void;
  isSyncing?: boolean;
}) {
  return (
    <div className="border-t border-[#ececec] px-5 pb-5 pt-4">
      <div className="flex items-center justify-between text-[16px]">
        <span className="font-medium text-[#333]">Total</span>
        {isSyncing ? (
          <div className="h-5 w-16 animate-pulse rounded bg-[#e0e0e0]" />
        ) : (
          <span className="font-semibold text-[#333]">
            {totals.discountActive ? (
              <>
                <span className="mr-1 font-normal text-[#828282] line-through">
                  {formatUsd(totals.totalBeforeDiscount)}
                </span>
                {formatUsd(totals.total)}
              </>
            ) : (
              formatUsd(totals.total)
            )}
          </span>
        )}
      </div>
      <p className="mb-1 text-[13px] text-[#828282]">
        Shipping calculated at checkout
      </p>

      <PrimaryButton
        id="btn-bag-checkout"
        href={checkoutUrl}
        onClick={onCheckout}
        className="mt-4 block w-full"
      >
        Checkout
      </PrimaryButton>
      <SecondaryButton
        id="btn-bag-create-another"
        href="/comix/stories"
        onClick={() => {
          trackEvent("Bag - Create Another Clicked", { total: totals.total });
          onCreateAnother();
        }}
        className="mt-3 block w-full"
      >
        Create another book
      </SecondaryButton>
    </div>
  );
}
